import { render, staticRenderFns } from "./DepositStatistics.vue?vue&type=template&id=25850fee&scoped=true&"
import script from "./DepositStatistics.vue?vue&type=script&lang=js&"
export * from "./DepositStatistics.vue?vue&type=script&lang=js&"
import style0 from "./DepositStatistics.vue?vue&type=style&index=0&id=25850fee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25850fee",
  null
  
)

export default component.exports